function toggleProductInCart(checkbox) {
    var productId = checkbox.value;
    console.log('Product ID:', productId);
    if (checkbox.checked) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: productId,
                quantity: 1
            },
            dataType: 'json',
            success: function(response) {
                console.log('Added to cart:', response);
            },
            error: function(XMLHttpRequest, textStatus) {
                console.error('Error adding to cart:', textStatus, XMLHttpRequest.responseJSON);
            }
        });
    } else {
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                id: productId,
                quantity: 0
            },
            dataType: 'json',
            success: function(response) {
                console.log('Removed from cart:', response);
            },
            error: function(XMLHttpRequest, textStatus) {
                console.error('Error removing from cart:', textStatus, XMLHttpRequest.responseJSON);
            }
        });
    }
}


 function initReviewSlider() {
  var swiper = new Swiper(".MRSslider", {
    slidesPerView: 5,
    spaceBetween: 20,
    loop: true,
    freeMode: true, 
    autoplay: {
      delay: 3000, 
      disableOnInteraction: false
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 10
      },
      769: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1000: {
        slidesPerView: 5,
        spaceBetween: 20
      }
    }
  });
}
function initMupsellSlider() {
  var swiper = new Swiper(".MupsellSwiper", {
    speed: 1000,
    spaceBetween: 15,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: "bullets",
    },
    navigation: {
      nextEl: '.m-swiper-button-next',
      prevEl: '.m-swiper-button-prev',
    },
    breakpoints: {
      769: {
        slidesPerView: 2,
      }
    }
  });
}
(function () {
  if (window.__mcartPopupInit) return;
  window.__mcartPopupInit = true;

  function getOverlay() {
    return document.querySelector('.mcart-upsell-popup-overlay');
  }

  function closePopup() {
    const overlay = getOverlay();
    if (!overlay) return;
    overlay.classList.remove('active');
    document.body.classList.remove('mcart-popupActive');
  }

  document.addEventListener('click', function (e) {
    const overlay = getOverlay();
    if (!overlay || !overlay.classList.contains('active')) return;

    if (e.target.closest('.mcart-upsell-popup-close')) {
      closePopup();
      return;
    }

    if (e.target === overlay) {
      closePopup();
      return;
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.mcart-upsell-popup-text')) {
      const overlay = getOverlay();
      if (overlay) {
        overlay.classList.add('active');
        document.body.classList.add('mcart-popupActive');
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    const overlay = getOverlay();
    if (e.key === 'Escape' && overlay && overlay.classList.contains('active')) {
      closePopup();
    }
  });

})();
  
function initFeaturesSlider() {
  $('.M-features-wrapper').slick({
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow:"<button type='button' class='slick-prev Mtp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next Mtp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>"
  });
}


// function mupsellPopup() {
//   const triggers = document.querySelectorAll('.mupsell-popup-text');
//   const body = document.body;

//   triggers.forEach(trigger => {
//     trigger.addEventListener('click', () => {
//       const popup = trigger.closest('.mupsell-container')?.querySelector('.mupsell-popup-overlay');
//       const header = document.querySelector('.shopify-section--header');
      
//       if (popup) {
//         popup.classList.add('active');
//         header?.classList.add('mpopupActive');
//         body.classList.add('mpopupActive');

//         const closeBtn = popup.querySelector('.mupsell-popup-close');
//         closeBtn?.addEventListener('click', () => {
//           popup.classList.remove('active');
//           header?.classList.remove('mpopupActive');
//           body.classList.remove('mpopupActive');
//         });

//         popup.addEventListener('click', (e) => {
//           if (e.target === popup) {
//             popup.classList.remove('active');
//             header?.classList.remove('mpopupActive');
//             body.classList.remove('mpopupActive');
//           }
//         });
//       }
//     });
//   });
// }


function mupsellPopup() {
  const triggers = document.querySelectorAll('.mupsell-popup-text');
  const body = document.body;

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const classes = Array.from(trigger.classList);
      const match = classes.find(cls => cls.startsWith('mupsell-popup-text-'));
      if (match) {
        const index = match.split('-').pop();
        const popup = document.querySelector(`.mupsell-popup-overlay-${index}`);
        const header = document.querySelector('.shopify-section--header');
        
        if (popup) {
          popup.classList.add('active');
          header?.classList.add('mpopupActive');
          body.classList.add('mpopupActive');

          const closeBtn = popup.querySelector('.mupsell-popup-close');
          closeBtn?.addEventListener('click', () => {
            popup.classList.remove('active');
            header?.classList.remove('mpopupActive');
            body.classList.remove('mpopupActive');
          });

          popup.addEventListener('click', (e) => {
            if (e.target === popup) {
              popup.classList.remove('active');
              header?.classList.remove('mpopupActive');
              body.classList.remove('mpopupActive');
            }
          });
        }
      }
    });
  });
}

document.addEventListener('click', function(e) {
  const input = e.target.closest('.mcart-upsell-toggle-input');
  if (!input) return;

  const form = input.closest('.mcart-upsell-form');
  const variantId = form.querySelector('[name="id"]').value;

  input.disabled = true;
  if (input.checked) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(res => res.json())
    .then(data => {
      console.log('Added:', data);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(err => {
      console.error(err);
      input.checked = false;
    })
    .finally(() => {
      input.disabled = false;
    });
  }
  else {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    })
    .then(res => res.json())
    .then(data => {
      console.log('Removed:', data);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(err => {
      console.error(err);
      input.checked = true;
    })
    .finally(() => {
      input.disabled = false;
    });
  }
});